
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/roi-car-wars",
      function () {
        return require("private-next-pages/nm/news/roi-car-wars.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/roi-car-wars"])
      });
    }
  